import React, { useState } from 'react';
import { FaArrowLeft, FaChevronDown } from 'react-icons/fa';
import GeneralTab from './tabs/GeneralTab';
import LandTab from './tabs/LandTab';
import ConstructionTab from './tabs/ConstructionTab';
import ValuationTab from './tabs/ValuationTab';
import LegalTab from './tabs/LegalTab';
import FiscalTab from './tabs/FiscalTab';
import PhotosTab from './tabs/PhotosTab';
import { formatMoney, formatNum } from '../../services/cadastral.service';
import styles from '../../styles/Cadastral.module.css';

const TABS = [
  { id: 'overview', label: 'General' },
  { id: 'land', label: 'Terreno' },
  { id: 'construction', label: 'Construcciones' },
  { id: 'valuation', label: 'Valuación' },
  { id: 'legal', label: 'Legal' },
  { id: 'tax', label: 'Fiscal' },
  { id: 'photos', label: 'Fotografías' }
];

function tagClass(classification) {
  if (classification === 'Predio Urbano Edificado') return styles.tagBuiltProperty;
  if (classification === 'Predio Urbano Baldío') return styles.tagVacantProperty;
  return styles.tagRuralProperty;
}

export default function CadastralRecordDrawer({ data, onReturnToMap }) {
  const [activeTab, setActiveTab] = useState('overview');

  if (!data || !data.record || !data.file) return null;
  const { record, file } = data;

  const metrics = [
    { label: 'Superficie de terreno', val: formatNum(file.land.area), unit: 'm²' },
    { label: 'Sup. de construcción', val: file.totalBuildingArea ? formatNum(file.totalBuildingArea) : '0.00', unit: 'm²' },
    { label: 'Valor catastral', val: formatMoney(file.cadastralValue), unit: '', accent: true },
    { label: 'Ejercicio fiscal', val: file.registry.fiscalYear, unit: '' }
  ];

  return (
    <div className={styles.recordViewer}>
      <div className={styles.recordViewerHeader}>
        <button
          type="button"
          className={styles.btnBack}
          onClick={onReturnToMap}
          id="returnToMapButton"
          title="Regresar a vista de mapa completo"
        >
          <FaArrowLeft size={14} />
          <span>Volver al mapa</span>
        </button>
        <span className={styles.vbHint}>Expediente catastral</span>
      </div>

      <div className={styles.propertyHero}>
        <div className={styles.phTop}>
          <div>
            <div className={styles.recordKeyLabel}>Clave catastral</div>
            <div className={styles.recordKey}>{record.propertyKey}</div>
          </div>
          <span className={`${styles.tag} ${tagClass(record.classification)}`}>
            {record.classification}
          </span>
        </div>
        <div className={styles.dir}>
          {record.address || 'Sin domicilio registrado'}
          <span className={styles.sub}>
            {record.neighborhood ? `${record.neighborhood} · ` : ''}
            {record.delegation ? `Delegación ${record.delegation} · ` : ''}
            Municipio de Querétaro, Qro.
          </span>
        </div>
      </div>

      <div className={styles.metrics}>
        {metrics.map((metric, index) => (
          <div
            key={index}
            className={`${styles.metric} ${metric.accent ? styles.isAccent : ''}`}
          >
            <div className={styles.mLbl}>{metric.label}</div>
            <div className={styles.mVal}>
              {metric.val}
              {metric.unit && <small>{metric.unit}</small>}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              type="button"
              className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <label className={styles.responsiveTabSelector}>
          <select
            aria-label="Sección del expediente"
            value={activeTab}
            onChange={event => setActiveTab(event.target.value)}
          >
            {TABS.map(tab => (
              <option key={tab.id} value={tab.id}>
                {tab.label}
              </option>
            ))}
          </select>
          <FaChevronDown aria-hidden="true" size={13} />
        </label>
      </div>

      <div className={styles.tabBody}>
        {activeTab === 'overview' && <GeneralTab record={record} file={file} />}
        {activeTab === 'land' && <LandTab file={file} />}
        {activeTab === 'construction' && <ConstructionTab file={file} />}
        {activeTab === 'valuation' && <ValuationTab file={file} />}
        {activeTab === 'legal' && <LegalTab file={file} />}
        {activeTab === 'tax' && <FiscalTab file={file} />}
        {activeTab === 'photos' && <PhotosTab file={file} />}
      </div>
    </div>
  );
}
